import { Event } from 'models';

import { useQuery } from 'query';
import { getEvent } from '../services';

import { getEventQueryKey } from './';

export const useEventQuery = ({ eventId }: { eventId: string }) =>
  useQuery<Event>(
    getEventQueryKey({ eventId }),
    async () => {
      const response = await getEvent(eventId);
      return new Event(response.data.event);
    },
    {
      useErrorBoundary: true,
    },
  );
